/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diet_VeganInputs */

const en_diet_vegan = /** @type {(inputs: Diet_VeganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vegan`)
};

const de_diet_vegan = /** @type {(inputs: Diet_VeganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vegan`)
};

/**
* | output |
* | --- |
* | "Vegan" |
*
* @param {Diet_VeganInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const diet_vegan = /** @type {((inputs?: Diet_VeganInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diet_VeganInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_diet_vegan(inputs)
	return en_diet_vegan(inputs)
});